module.exports = __webpack_public_path__ + "static/img/挂锁.b99c948.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/guaLock/挂锁.jpg
// module id = y0Bm
// module chunks = 0